
import React, { useState } from 'react';
import { Button } from '../base/Button';

export const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white shadow-sm">
      <nav className="px-6 py-3">
        <div className="flex items-center justify-between max-w-7xl mx-auto">
          <div className="flex items-center">
            <h1 className="text-2xl font-bold">
              <a href="/" className="flex items-center">
                <img 
                  src="https://static.readdy.ai/image/8a3a8619d31942f95a593de8958f2ef8/d925ce72c51d6afc46e1204b8a69b068.png" 
                  alt="BiviLinks - Global Connections & Technology Solutions" 
                  className="h-14 w-auto"
                  style={{ maxWidth: '200px' }}
                />
              </a>
            </h1>
          </div>
          
          <div className="hidden md:flex items-center space-x-8">
            <a href="#inicio" className="text-gray-700 hover:text-[#00699b] transition-colors cursor-pointer font-medium">Inicio</a>
            <a href="#quienes-somos" className="text-gray-700 hover:text-[#00699b] transition-colors cursor-pointer font-medium">Quiénes Somos</a>
            <a href="#como-funciona" className="text-gray-700 hover:text-[#00699b] transition-colors cursor-pointer font-medium">Cómo Funciona</a>
            <a href="#beneficios" className="text-gray-700 hover:text-[#00699b] transition-colors cursor-pointer font-medium">Beneficios</a>
            <a href="#contacto" className="text-gray-700 hover:text-[#00699b] transition-colors cursor-pointer font-medium">Contacto</a>
          </div>
          
          <div className="hidden md:flex items-center space-x-4">
            <Button variant="outline" size="sm">Iniciar Sesión</Button>
            <Button size="sm">Registrarse</Button>
          </div>
          
          <button 
            className="md:hidden w-6 h-6 flex items-center justify-center"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl text-gray-700`}></i>
          </button>
        </div>
        
        {isMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-gray-200">
            <div className="flex flex-col space-y-4 pt-4">
              <a href="#inicio" className="text-gray-700 hover:text-[#00699b] transition-colors cursor-pointer font-medium">Inicio</a>
              <a href="#quienes-somos" className="text-gray-700 hover:text-[#00699b] transition-colors cursor-pointer font-medium">Quiénes Somos</a>
              <a href="#como-funciona" className="text-gray-700 hover:text-[#00699b] transition-colors cursor-pointer font-medium">Cómo Funciona</a>
              <a href="#beneficios" className="text-gray-700 hover:text-[#00699b] transition-colors cursor-pointer font-medium">Beneficios</a>
              <a href="#contacto" className="text-gray-700 hover:text-[#00699b] transition-colors cursor-pointer font-medium">Contacto</a>
              <div className="flex flex-col space-y-2 pt-4">
                <Button variant="outline" size="sm">Iniciar Sesión</Button>
                <Button size="sm">Registrarse</Button>
              </div>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};
